import { ChakraProvider } from '@chakra-ui/react';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { MsalProvider } from '@azure/msal-react';
import { App } from './App.js';
import { ErrorBoundary } from './components/ErrorBoundary.js';
import { appConfig, brand } from './lib/env.js';
import { msalInstance } from './lib/msal.js';
import { system } from './theme.js';

document.title = `${brand.name} — ${appConfig.appName} Admin`;
const favicon = document.querySelector<HTMLLinkElement>("link[rel='icon']");
if (favicon) {
  favicon.href = brand.logos.favicon;
}

await msalInstance.initialize();
// Must run before React renders. A popup/redirect return lands on this origin
// with ?code=; if the router mounts first, ProtectedRoute sends the window to
// /login and the auth code is dropped (popup stays open, parent never signs in).
await msalInstance.handleRedirectPromise();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <MsalProvider instance={msalInstance}>
      <ChakraProvider value={system}>
        <ErrorBoundary>
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </ErrorBoundary>
      </ChakraProvider>
    </MsalProvider>
  </StrictMode>,
);
